angular.module('picmonicng').filter('fullDateFormat', function () {
  return function (input) {
    input = moment(input).format('MM/DD/YYYY h:mma');
    return input;
  };
});
